import { Avatar } from 'antd';

const Group = Avatar.Group;

export { Group };
export default Avatar;
